import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import styles from "./devoteeManagement.module.scss";
import { object, string, ref, ValidationError, number } from "yup";
import CheckIcon from "@mui/icons-material/Check";
import commonStyles from "../../App.module.scss";
import {
  CustomInputLabel,
  CustomTextFeild,
  CommonButton,
  CustomRequiredInputLabel,
  ContactNumberInput,
  CommonOutlinedButton,
  CommonOutlinedVerifiedButton,
} from "../common/StyledComponents/StyledFields";
import ToastSuccess from "../common/toast/toastSuccess";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserSelectedRole,
} from "../../infrastructure/backendService";
import toast, { Toaster } from "react-hot-toast";
import { isEmpty, isNil } from "lodash";
import ToastError from "../common/toast/toastError";
import apiPath from "../../config/apiPaths.json";
import LOCALE from "../../config/en-us.json";
import SuccessPopup from "../devotee/donation/successPopup";
import ErrorPopup from "../common/ErrorPopup";
import constants from "../../config/constants.json";
import { displayPhoneNumberFormattoPlain } from "../common/phoneNumberFormats/phoneNumberFormats";

interface ErrorMessageTypes {
  firstName: string;
  lastName: string;
  email: string;
  workPhone: string;
  signInName: string;
  homePhone: string;
  verificationCode: string;
}

const PersonalInfo = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [registerNowButtonDisable, setRegisterNowButtonDisable] =
    useState(true);
  const [verifiedButton, setVerifiedButton] = useState(false);
  const [emailAndOtpHide, setEmailAndOtpHide] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    workPhone: "",
    signInName: "",
    homePhone: "",
    verificationCode: "",
  });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    firstName: "",
    lastName: "",
    email: "",
    workPhone: "",
    homePhone: "",
    signInName: "",
    verificationCode: "",
  });

  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );

  let emailInputLabel;
  if (hasManagerLevelRole) {
    emailInputLabel = CustomRequiredInputLabel("Email", true);
  } else {
    emailInputLabel = CustomRequiredInputLabel("Email", false);
  }

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  const validationSchema = object().shape({
    firstName: string().required("First Name is required"),
    lastName: string().required("Last Name is required"),
    email: string()
      .required("Email is required")
      .matches(emailRegex, "Please enter valid email address")
      .min(6, "Email must be at least 6 characters")
      .max(64, "Email cannot exceed 64 characters"),
    workPhone: string()
      .required("Work Phone Number is required")
      .matches(/^\d{10}$/, "Phone Number should be 10 digits"),
    homePhone: string()
      .required("Home Phone Number is required")
      .matches(/^\d{10}$/, "Phone Number should be 10 digits"),
    signInName: string()
      .required("Sign In  Name is required")
      .min(4, "Sign In  Name must be at least 4 characters")
      .max(10, "Sign In  Name cannot exceed 10 characters"),
  });
  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = {
      firstName: "",
      lastName: "",
      email: "",
      workPhone: "",
      homePhone: "",
      signInName: "",
      verificationCode: "",
    };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      saveApiCall();
      // userNameCheckAPI();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const saveApiCall = () => {
    const reqBody = {
      firstname: formData.firstName,
      lastname: formData.lastName,
      email: formData.email,
      phoneWork: formData.workPhone,
      phoneResidence: formData.homePhone,
      username: formData.signInName,
      verificationCode: formData.verificationCode,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.quickRgisterApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        console.log(res);
        const successMessage = LOCALE.QUICK_REGISTER;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //    duration: 10000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="Registration"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          workPhone: "",
          signInName: "",
          homePhone: "",
          verificationCode: "",
        });
        //  navigate("/");
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );

        // if (ErrorMessage === "User already existed with this username!!!") {
        //   toast.custom(<ToastError message={ErrorMessage} />, {
        //     duration: 2000,
        //   });
        // } else {
        //   toast.custom(<ToastError message={ErrorMessage} />, {
        //     duration: 2000,
        //   });
        // }
      });
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };
  const handleKeyDown = (e: any, fieldName: string) => {
    // Prevent entering numeric characters, spaces, and specific special characters
    if (
      (e.key >= "0" && e.key <= "9") ||
      e.key === " " || // prevent spaces
      /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-=`|"\s]/.test(e.key) // prevent specific special characters and whitespace
    ) {
      e.preventDefault();
    }
  };
  const handleKeyDownuser = (e: any, fieldName: string) => {
    if (!/[0-9a-zA-Z_]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validateEmail = () => {
    const { email } = formData;

    if (email.length < 6) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be at least 6 characters long.",
      });
    } else if (email.length >= 64) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be less than 64 characters long.",
      });
    } else if (!email.includes("@")) {
      setErrorMessage({
        ...errorMessage,
        email: "Please Enter Valid Email",
      });
    } else {
      setErrorMessage({ ...errorMessage, email: "" });
    }
  };

  return (
    <Box className={styles.PersonalInfoLayout}>
      <Toaster />
      <Typography className={styles.MainHeading}>
        Devotee Quick Register
      </Typography>
      <Typography className={styles.SubHeading}>Personal Info</Typography>
      <Grid className={styles.formLayout}>
        <Grid container spacing={2} sx={{ marginBottom: "16px" }}>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("First Name", true)}
            <CustomTextFeild
              id="firstName"
              fullWidth
              required
              value={formData.firstName}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, firstName: "" });
                  handleFieldChange("firstName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    firstName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              className={
                errorMessage.firstName
                  ? styles.errorTextField
                  : styles.textField
              }
              onKeyDown={(e) => handleKeyDown(e, "firstName")}
              placeholder="Enter Firstname"
            />
            {errorMessage.firstName && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.firstName}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Last Name", true)}
            <CustomTextFeild
              id="lastName"
              fullWidth
              required
              value={formData.lastName}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, lastName: "" });
                  handleFieldChange("lastName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    lastName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              className={
                errorMessage.lastName ? styles.errorTextField : styles.textField
              }
              onKeyDown={(e) => handleKeyDown(e, "lastName")}
              placeholder="Enter Lastname"
            />
            {errorMessage.lastName && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.lastName}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Email", true)}
            <CustomTextFeild
              id="email"
              fullWidth
              required
              value={formData.email}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, email: "" });
                handleFieldChange("email", e.target.value);
              }}
              onBlur={validateEmail}
              className={
                errorMessage.email ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Email"
            />
            {errorMessage.email && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.email}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ marginBottom: "16px", marginTop: "6px" }}
        >
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Work Phone", true)}
            <CustomTextFeild
              id="workPhone"
              // sx={{ width: "calc(100% - 30px)" }}
              fullWidth
              type="tel"
              required
              value={formData.workPhone}
              onChange={(e) => {
                const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                setErrorMessage({ ...errorMessage, workPhone: "" });
                handleFieldChange("workPhone", slicedNumber);
              }}
              className={
                errorMessage.workPhone
                  ? styles.errorTextFieldphonenumber
                  : styles.textField
              }
            />
            {errorMessage.workPhone && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.workPhone}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Home Phone", true)}
            <CustomTextFeild
              id="homePhone"
              fullWidth
              // sx={{ width: "calc(100% - 30px)" }}
              type="tel"
              required
              value={formData.homePhone}
              onChange={(e) => {
                const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                setErrorMessage({ ...errorMessage, homePhone: "" });
                handleFieldChange("homePhone", slicedNumber);
              }}
              className={
                errorMessage.homePhone
                  ? styles.errorTextFieldphonenumber
                  : styles.textField
              }
            />
            {errorMessage.homePhone && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.homePhone}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("Sign-In Name", true)}
            <CustomTextFeild
              id="signInName"
              fullWidth
              required
              value={formData.signInName}
              onChange={(e) => {
                setErrorMessage({ ...errorMessage, signInName: "" });
                handleFieldChange("signInName", e.target.value);
              }}
              className={
                errorMessage.signInName
                  ? styles.errorTextField
                  : styles.textField
              }
              onKeyDown={(e) => handleKeyDownuser(e, "signInName")}
              placeholder="Enter Sign-In Name"
            />
            {errorMessage.signInName && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.signInName}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
      <CommonButton onClick={handleSave} id="registerNow">
        Register Now
      </CommonButton>
    </Box>
  );
};

export default PersonalInfo;
